import { Form, InputNumber, Typography, Divider } from 'antd'
import { useFFEStore } from '../../store/ffeStore'
import { DeliveryCostsButton } from './DeliveryCosts/DeliveryCostsButton'
import { PurchaseOrdersButton } from './PurchaseOrders/PurchaseOrdersButton'
import { BulkImageUploadButton } from './BulkImageUpload/BulkImageUploadButton'
import { useCompanyStore } from '../../store/company/companyStore'
import { useApi } from '../../services/ApiContext'
import { useTaxSystem } from '../../hooks/useTaxSystem'

const { Title } = Typography

export const DocumentSettings = () => {
  const settings = useFFEStore((state) => state.document.settings)
  const updateSettings = useFFEStore((state) => state.updateSettings)
  const { company } = useCompanyStore((state) => state)

  const api = useApi()

  const taxSystem = useTaxSystem()

  return (
    <>
      <Title level={5}>Document</Title>

      <Form.Item
        label="Default Margin %"
        tooltip="This margin will be applied to line items when changing the cost price"
      >
        <InputNumber
          value={settings.defaultMargin}
          onChange={(value) => {
            updateSettings({
              ...settings,
              defaultMargin: value || 0
            })
          }}
          min={-100}
          precision={1}
        />
      </Form.Item>

      <Divider />

      <BulkImageUploadButton />

      <Divider />

      <DeliveryCostsButton />

      <Divider />

      <PurchaseOrdersButton />

      <Divider />

      <Title level={5}>Tax</Title>

      {/* <Form.Item
        label={`${taxSystem.name} Inclusive`}
        tooltip={`Whether prices include ${taxSystem.name}`}
      >
        <Switch
          checked={settings.taxInclusive}
          onChange={(checked) =>
            updateSettings({
              ...settings,
              taxInclusive: checked
            })
          }
        />
      </Form.Item> */}

      <Form.Item label={`${taxSystem.name} Rate %`}>
        <InputNumber
          value={company.settings.taxRate}
          onChange={(value) =>
            api.syncSettings({
              taxRate: value || 0
            })
          }
          min={0}
          max={100}
          precision={1}
        />
      </Form.Item>

      {/* <Divider />

      <SpaceLinksSettings /> */}
    </>
  )
}
